import {
  PageLayout,
  PageLayoutContent,
} from "@clockwise/web-commons/src/ui/page-layout/PageLayout";
import React from "react";
import Helmet from "react-helmet";
import { GatewayTest } from "../components/gateway-test/GatewayTest";

const GatewayTestPage = () => {
  return (
    <>
      <Helmet>
        <title>Test Page · Clockwise</title>
      </Helmet>
      <PageLayout>
        <PageLayoutContent>
          <GatewayTest />
        </PageLayoutContent>
      </PageLayout>
    </>
  );
};

export default GatewayTestPage;
